import styled from 'styled-components';

export const Page = styled.main`
  min-height: 100vh;
  width: 100%;
  margin-top: -72px;
  padding: calc(72px + clamp(0.75rem, 1.5vh, 1.25rem)) 1rem 2.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  background: linear-gradient(160deg, rgba(8,8,8,.98) 0%, rgba(12,18,32,.97) 50%, rgba(8,8,8,.98) 100%);
  background-color: #080b12;

  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    filter: blur(72px);
    z-index: 0;
    pointer-events: none;
    width: 330px;
    height: 330px;
    background: rgba(56, 189, 248, 0.22);
    top: 8%;
    left: -120px;
  }

  @media (max-width: 768px) {
    margin-top: -60px;
    padding-top: calc(60px + 0.65rem);
  }
`;

export const Card = styled.section`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 560px;
  background:
    linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%),
    rgba(15, 23, 42, 0.74);
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 22px;
  padding: clamp(1.05rem, 2.4vw, 1.5rem);
  box-shadow:
    0 26px 50px -28px rgba(2, 6, 23, 0.9),
    0 1px 0 rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(11px);

`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.72rem;
  margin-bottom: 0.55rem;
  padding: 0.1rem 0 0.35rem;
`;

export const Icon = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  box-shadow: 0 10px 18px rgba(2, 6, 23, 0.46);
`;

export const Title = styled.h1`
  margin: 0;
  color: #f8fafc;
  font-family: 'Poppins', sans-serif;
  font-size: clamp(1.3rem, 2.5vw, 1.75rem);
  letter-spacing: -0.015em;
`;

export const CardSubtitle = styled.p`
  color: rgba(226, 232, 240, 0.86);
  font-size: 0.92rem;
  line-height: 1.6;
  margin: 0 0 0.9rem;
`;

export const AuthMessage = styled.div`
  margin: 0.9rem 0;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid ${({ $success }) => ($success ? 'rgba(74, 222, 128, 0.32)' : 'rgba(248, 113, 113, 0.32)')};
  background: ${({ $success }) => ($success ? 'rgba(22, 101, 52, 0.23)' : 'rgba(127, 29, 29, 0.24)')};
  color: ${({ $success }) => ($success ? '#dcfce7' : '#fee2e2')};
  font-weight: 600;
  line-height: 1.45;
`;

export const Form = styled.form`
  display: grid;
  gap: 1rem;
`;

export const FieldWrap = styled.label`
  display: grid;
  gap: 0.45rem;
`;

export const FieldLabel = styled.span`
  color: #cbd5e1;
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.015em;
  text-transform: uppercase;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.87rem 0.98rem;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.38);
  background: #0b1222;
  color: #f8fafc;
  transition: border-color 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
  -webkit-appearance: none;
  appearance: none;

  &::placeholder {
    color: #94a3b8;
  }

  &:hover {
    border-color: rgba(148, 163, 184, 0.62);
    background: #0f172a;
  }

  &:focus {
    outline: none;
    border-color: #60a5fa;
    background: #0f172a;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.22);
  }

  caret-color: #f8fafc;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: #f8fafc;
    -webkit-box-shadow: 0 0 0 1000px #0b1222 inset !important;
    box-shadow: 0 0 0 1000px #0b1222 inset !important;
    transition: background-color 9999s ease-in-out 0s;
  }

  &[type='password']:-webkit-autofill,
  &[type='password']:-webkit-autofill:hover,
  &[type='password']:-webkit-autofill:focus,
  &[type='password']:-webkit-autofill:active {
    -webkit-text-fill-color: #f8fafc;
    -webkit-box-shadow: 0 0 0 1000px #0b1222 inset !important;
    box-shadow: 0 0 0 1000px #0b1222 inset !important;
  }
`;

export const AuthActionButton = styled.button`
  background: linear-gradient(#f0c876 0%, #b47806 100%);
  color: #0e0906;
  border: 1px solid rgba(240, 200, 118, 0.52);
  border-radius: 12px;
  padding: 0.9rem 1rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  text-transform: uppercase;
  box-shadow: 0 16px 30px -14px rgba(139,94,0,.78), 0 1px 0 rgba(255,255,255,.18) inset;
  cursor: pointer;
  width: 100%;
  margin-top: 0.3rem;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px) scale(1.002);
    box-shadow: 0 20px 34px -12px rgba(139,94,0,.84), 0 1px 0 rgba(255,255,255,.18) inset;
    filter: saturate(1.05);
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }
`;

export const LinkButton = styled.button`
  margin-top: 1rem;
  background: transparent;
  border: 0;
  color: #bae6fd;
  font-weight: 700;
  padding: 0;
  cursor: pointer;

  &:hover {
    color: #f0f9ff;
    text-decoration: underline;
  }
`;
